:host {
  @apply block;
}

.header {
  @apply flex justify-between;
  @apply py-0 px-1;
}

:host([scale="s"]) {
  .text {
    @apply text-n1h my-2;
  }
  .chevron {
    @apply h-9;
  }
}

:host([scale="m"]) {
  .text {
    @apply text-0h my-3;
  }
  .chevron {
    @apply h-12;
  }
}

:host([scale="l"]) {
  .text {
    @apply text-1h my-4;
  }
  .chevron {
    block-size: 3.5rem;
  }
}

.chevron {
  @apply text-color-3
    bg-foreground-1
    focus-base
    -mx-1
    box-content
    flex
    flex-grow-0
    cursor-pointer
    items-center
    justify-center
    border-none
    px-1
    outline-none
    transition-default;
  inline-size: calc(100% / 7);

  &:focus {
    @apply focus-inset;
  }

  &:hover,
  &:focus {
    @apply text-color-1 bg-foreground-2 fill-color-1;
  }

  &:active {
    @apply bg-foreground-3;
  }

  &[aria-disabled="true"] {
    @apply pointer-events-none opacity-0;
  }
}

.text {
  @apply my-auto
    w-full
    flex
    flex-auto
    items-center
    justify-center
    text-center
    leading-none;
}

.text--reverse {
  @apply flex-row-reverse;
}

.month,
.year,
.suffix {
  @apply text-color-1
    bg-foreground-1
    mx-1
    my-auto
    inline-block
    font-medium
    leading-tight;
  font-size: inherit;
}

.year {
  @apply font-inherit
    focus-base
    relative
    w-10
    border-none
    bg-transparent
    text-center;
  &:hover {
    @apply duration-100 ease-in-out;
    transition-property: outline-color;
    outline: 2px solid var(--calcite-color-border-2);
    outline-offset: 2px;
  }
  &:focus {
    @apply focus-outset;
  }
}

.year--suffix {
  @apply text-left;
}

.year-wrap {
  @apply relative;
}

.suffix {
  @apply top-0
    whitespace-nowrap
    text-start;
  inset-inline-start: 0;
}

@include base-component();
